module.exports = __webpack_public_path__ + "static/media/WS.b8a030f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ministries/WS.svg
// module id = 254
// module chunks = 0